import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArmMatErrorComponent } from './arm-mat-error.component';



@NgModule({
  declarations: [
    ArmMatErrorComponent
  ],
  exports: [
    ArmMatErrorComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ArmMatErrorModule { }
